/**
 *
 * @export
 * @class File
 */
  

 export class Log {
    //Fields
    usid: number;
    aid:number;
    path:string;
    name:string;
    size:number;
    type:number;
    dateTime:string;
    encrypted:boolean;
    from:string;
    to:string;
  
    constructor(
        usid: number,    
        aid:number,
        name: string,
        path:string,
        size:number,
        type:number,
        dateTime:string,
        encrypted:boolean,
        from:string,
        to:string,
    ) {
      this.usid=usid;
      this.aid=aid;
      this.name=name;
      this.path=path;
      this.size= size;
      this.type=type;
      this.dateTime=dateTime;
      this.encrypted=encrypted;
      this.from=from;
      this.to=to;
    } 
    
   /**
    * name
    */
     
}
  